(() => {
  if (window.__class1ContactAnalyticsReady) return;
  window.__class1ContactAnalyticsReady = true;

  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0) return;
    const link = event.target.closest('a[href]');
    if (!link) return;

    let destination;
    try {
      destination = new URL(link.href, window.location.origin);
    } catch {
      return;
    }
    let contactMethod;
    if (destination.protocol === 'https:' && ['wa.me', 'api.whatsapp.com'].includes(destination.hostname)) {
      contactMethod = 'whatsapp';
    } else if (destination.protocol === 'tel:') {
      contactMethod = 'phone';
    } else if (destination.protocol === 'mailto:') {
      contactMethod = 'email';
    } else {
      return;
    }

    const privacy = window.Shopify?.customerPrivacy;
    const analytics = window.Shopify?.analytics;
    if (!privacy?.analyticsProcessingAllowed?.() || typeof analytics?.publish !== 'function') return;
    const storefrontPath = window.location.pathname;
    if (!/^\/(?:$|(?:products|collections|pages)\/[a-z0-9-]+\/?$|blogs\/[a-z0-9-]+(?:\/[a-z0-9-]+)?\/?$|cart\/?$|search\/?$)/.test(storefrontPath)) return;

    const data = {
      contact_method: contactMethod,
      page_location: `${window.location.origin}${window.location.pathname}`,
    };
    const productMatch = window.location.pathname.match(/\/products\/([a-z0-9-]+)\/?$/);
    if (productMatch) {
      data.product_handle = productMatch[1];
      const product = document.querySelector('[data-class1-product-section]');
      const state = product?.dataset.class1State;
      if (['in_stock', 'sourceable', 'unavailable'].includes(state)) data.source_state = state;
      const variantId = product?.closest('product-info')?.querySelector('input[name="id"]')?.value;
      if (variantId && /^\d+$/.test(variantId)) data.variant_id = variantId;
    } else {
      const brand = document.querySelector('[data-class1-brand]')?.dataset.class1Brand;
      if (brand) data.brand = brand;
    }
    analytics.publish('class1_specialist_contact_clicked', data);
  });
})();
